module.exports = __webpack_public_path__ + "static/media/step_3.324bdd99.png";